import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { STATUS } from "constants/statusConstant";
import B2bpostSaleView from "components/sales/leadDetails/postsaleDetail/b2bAlliance/b2bpostSaleView"
import PostsaleView from './postsaleDetail/postsaleDetail';

const PostsaleLeadType = ({
    details,
    renewContracts,
    clientBrd=null,
    modificationData,
    requiredDocuments,
    contractInvoicePreview,
    setIsLoading,
    leadTypeId = null,
}) => {
    
    const [teamId, setTeamId] = useState();
    useEffect(() => {
        (async () => {
            const team =
                (await JSON.parse(localStorage.getItem("profileDetails"))) &&
                JSON.parse(localStorage.getItem("profileDetails"))[0]?.team_id;
            setTeamId(team);
        })();
    }, [])
    return (
        <>
        <PostsaleView 
                details={details}
                renewContracts={renewContracts}
                clientBrd={clientBrd}
                modificationData={modificationData}
                requiredDocuments={requiredDocuments}
                contractInvoicePreview={contractInvoicePreview}
                setIsLoading={setIsLoading}
                leadTypeId={leadTypeId}
                />
            {/* { teamId === STATUS.B2BALLIANCE ?
                <B2bpostSaleView
                    details={details}
                /> :
                <PostsaleView 
                details={details}
                />
            } */}
        </>
    )
}

PostsaleLeadType.propTypes = {

}

export default PostsaleLeadType
